export default __webpack_public_path__ + "static/media/2829 knife block A top.cba70ddf.png";